module.exports = __webpack_public_path__ + "img/Icon-Design.ada06045.jpg";